<template>
	<div class="step-navigator" :class="{ hide: isLastStep }">
		<div class="step-navigation">
			<div>
				<button
					class="prev button-secondary"
					id="visualizer--previous-step"
					:data-current-step="currentStep"
					:data-previous-step="previousStepId"
					:class="{show: previousStepId}"
					@click="moveToPreviousStep"
				>&lt; {{ previousText }}</button>
			</div>
			<div>
				<button
					class="next"
					id="visualizer--next-step"
					:data-current-step="currentStep"
					:data-next-step="nextStepId"
					:class="{show: nextStepId}"
					@click="moveToNextStep"
				>{{ nextText }} &gt;</button>
			</div>
		</div>
		<!-- <ProgressBar /> REMOVING PROGRESS BAR 20220315 -->
	</div>
</template>

<script>
import { mapState } from "vuex";
import StepValidator from "@/components/StepValidator";
// import ProgressBar from "@/components/ProgressBar"; REMOVING PROGRESS BAR 20220315

export default {
	name: "StepNavigation",
	extends: StepValidator,
	// components: { ProgressBar }, REMOVING PROGRESS BAR 20220315
	computed: {
		activeSteps() {
			return this.$store.getters["configurator/activeSteps"];
		},
		allStepIds() {
			return this.activeSteps.map(step => step.id);
		},
		previousStepIds() {
			let stepIndex = this.allStepIds.indexOf(this.currentStep);
			return this.allStepIds.slice(0, stepIndex);
		},
		nextStepIds() {
			let stepIndex = this.allStepIds.indexOf(this.currentStep) + 1;
			return this.allStepIds.slice(stepIndex);
		},
		previousStepId() {
			return this.previousStepIds.length > 0 ? this.previousStepIds[this.previousStepIds.length - 1] : null;
		},
		nextStepId() {
			return this.nextStepIds.length > 0 ? this.nextStepIds[0] : null;
		},
		isLastStep() {
			return this.nextStepIds.length === 0;
		},
		previousText() {
			return this.isLastStep ? "Back to edit" : "Previous";
		},
		nextText() {
			return "Next";
		},
		...mapState({
			config: state => state.configurator.config,
			currentStep: state => state.configurator.currentStep
		})
	},
	methods: {
		moveToPreviousStep() {
			if (this.previousStepId) {
				this.$store.dispatch("configurator/setCurrentStep", this.previousStepId);
			}
		},
		moveToNextStep() {
			if (this.isValidCurrentStep() && this.nextStepId) {
				// if no validation errors found, update store with next step id.
				this.$store.dispatch("configurator/setCurrentStep", this.nextStepId);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.step-navigator {
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 5;
	width: 100%;
	background: #fff;
	background: #f5f4f0;
	transition: bottom 500ms;

	&.hide {
		position: relative;
	}

	.step-navigation {
		display: flex;
		justify-content: space-between;
		margin: 0 -8px;
		padding: 16px;

		> div {
			width: 100%;
			margin: 0 8px;

			&.hide {
				width: auto;
				overflow: hidden;
				+ div {
					width: auto;
					@media only screen and (min-width: $viewport-tablet) {
						width: 50%;
					}
				}
			}

			.prev {
				transform: translateX(-100px);
			}
			.next {
				transform: translateX(100px);
			}

			.prev,
			.next {
				width: 100%;
				opacity: 0;
				transition: all 200ms;
				pointer-events: none;
				white-space: nowrap;

				&.show {
					opacity: 1;
					transform: none;
					pointer-events: auto;
				}
			}
		}
	}

	@media only screen and (min-width: $viewport-desktop) {
		position: absolute;
		&.hide {
			position: absolute;
		}
	}
}
</style>
